<template>
  <b-container fluid>
    <backlink />
    <h1>Autorisations des rôles</h1>

    <b-row>
      <b-col>
        <div class="ibox">
          <div class="ibox-content">
            <div class="filters">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1 search-bar">
                  <b-form-group inline class="mb-0">
                    <b-input-group>
                      <label class="mb-0 align-self-center">
                        <i class="far fa-search fa-lg"></i>
                      </label>
                      <b-form-input v-model="filter" placeholder="Rechercher" />
                      <b-input-group-append v-if="filter">
                        <b-button :disabled="!filter" @click="filter = ''">
                          <i class="far fa-times"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </div>
              </div>
            </div>
            <div class="table-wrapper mt-2">
              <b-table
                class="authorization-table"
                ref="table"
                hover
                show-empty
                :fields="fields"
                :items="authorizations"
                :filter="filter"
                :busy="isBusy"
              >
                <template slot="table-busy">
                  <div class="text-center my-2">
                    <div v-if="isBusy" class="loader"></div>
                    Les données sont en cours de chargement...
                  </div>
                </template>
                <template slot="empty" slot-scope="scope">
                  <div class="text-center mt-2">Cette liste est vide pour le moment</div>
                </template>
                <template v-for="role in roles" :slot="role" slot-scope="data">
                  <b-button
                    :key="role"
                    v-b-tooltip.hover
                    :title="
                      data.item[role]
                        ? 'Cliquez pour retirer l\'autorisation'
                        : 'Cliquez pour ajouter l\'autorisation'
                    "
                    variant="outline-secondary"
                    @click="
                      changeState(data.item.feature, data.item.action, role, !data.item[role])
                    "
                  >
                    <i v-if="data.item[role]" class="far fa-check fa-lg"></i>
                    <i v-else class="far fa-times fa-lg"></i>
                  </b-button>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "RoleAuthorization",
  data() {
    return {
      authorizations: [],
      roles: [],
      fields: [],
      filter: null,
      isBusy: false,
    };
  },
  methods: {
    extract_feature(key) {
      return key ? key.split("_")[0] : null;
    },
    extract_action(key) {
      return key ? key.split("_")[1] : null;
    },
    changeState(feature, action, role, state) {
      state = state ? 1 : 0;
      this.$http
        .post("authorization", {
          type: "role",
          id: role,
          action: action,
          feature: feature,
          value: state,
        })
        .then((response) => {
          const authorization_index = this.authorizations.findIndex(
            (i) => i.feature == feature && i.action == action
          );
          let authorization_object = this.authorizations.find(
            (i) => i.feature == feature && i.action == action
          );
          authorization_object[role] = state;
          this.authorizations.splice(authorization_index, 1, authorization_object);
          this.$toastr.success("Modification enregistrée");
        });
    },
  },
  mounted() {
    this.isBusy = true;
    this.$http.get("role/authorization").then((response) => {
      let user_role = this.$store.getters["auth/roles"];
      this.roles = [
        ...(!user_role.includes("ROLE_SUPER_ADMIN") ? this.$store.getters["auth/roles"] : []),
        ...response.data.sub_roles,
      ];

      let fields = [{ key: "libelle", label: "Fonctionnalité - Action" }];
      this.roles.forEach((role) => {
        fields.push({
          key: role,
          label: this.$t("role." + role),
        });
      });
      this.fields = fields;

      let authorizations = [];
      for (let index in response.data.authorizations) {
        let feature = this.extract_feature(index);
        let action = this.extract_action(index);
        let value = response.data.authorizations[index];

        // On masque certaines associations feature/action
        if (action == "access" && feature != "desktop" && feature != "mobile") {
          continue;
        }
        if ((feature == "desktop" || feature == "mobile") && action != "access") {
          continue;
        }
        if (action == "technician") {
          continue;
        }
        if (
          (action == "im-preparator" || action == "ot-preparator" || action == "snl-preparator") &&
          feature != "renting" &&
          feature != "business-return"
        ) {
          continue;
        }
        if (feature == "not-billable-business" && action != "index") {
          continue;
        }
        if (action.includes("status-") && feature != "reference") {
          continue;
        }
        if (feature == "popup" && action != "show" && action != "edit") {
          continue;
        }

        let authorization = {
          feature: feature,
          action: action,
          libelle:
            this.$t("authorization.feature." + this.extract_feature(index)) +
            " - " +
            this.$t("authorization.action." + this.extract_action(index)),
        };
        this.roles.forEach((role) => {
          authorization[role] = value[role];
        });
        authorizations.push(authorization);
      }
      this.authorizations = authorizations;

      this.isBusy = false;
    });
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";

.filters {
  border: solid 1px $border-10p;
  padding: 6px 20px;
  border-radius: 25px;
  .search-bar {
    color: $text-50p;
    input {
      border: none;
      @extend .clanprobook;
    }
    button.btn {
      color: inherit;
      background: none;
      border: none;
    }
  }
}

button.btn {
  padding: 0;
  height: 40px;
  width: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Role/RoleAuthorization.vue